// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oblB","newExpiryDate":"styles_newExpiryDate__yh_TO","footer":"styles_footer__15gJ0"};